@let infoMessages = sessionFacade.infoMessages$ | async;

@if (infoMessages?.length > 0) {
  <div class="popover">
    @for (message of infoMessages; track message.id) {
      <div class="message-container">
        <div class="message-item">
          <eop-icon
            [identifier]="'info-circle-outlined'"
            [vaylensFont]="true"
            [color]="IconColor.INFO"></eop-icon>
          @if (message.messageKey) {
            <div class="message sub-heading-m">
              {{ message.messageKey | translate }}
              <div class="entities">
                @for (entity of message.entities; track $index; let first = $first) {
                  <div class="entity" [ngClass]="{ 'first-entity': first }">
                    {{ entity.name }} ({{ entity.id }})
                  </div>
                }
              </div>
            </div>
          }
          @if (message.link) {
            <div>
              <button
                eopButton
                [color]="ButtonColor.INFO"
                [size]="ButtonSize.MEDIUM"
                [routerLink]="[message.link]">
                {{ message.linkTextKey | translate }}
              </button>
            </div>
          }
          <eop-icon
            [identifier]="'close-outlined'"
            [vaylensFont]="true"
            [color]="IconColor.INFO"
            [clickable]="true"
            (click)="closeMessage(message.id)"></eop-icon>
        </div>
      </div>
    }
  </div>
}
